<template>
  <div class="wrapper" v-if="isdialogFormVisible">
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisible"
      width="60%"
      @close="hiddeBack"
      destroy-on-close
    >
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基础信息" name="first">
          <div class="tabs_views">
            <!-- <h3 style="color: black">设备图片:</h3> -->
            <div class="tabs_views_left"  >
              <el-tabs v-model="activeName1" @tab-click="handleClick">
                <el-tab-pane :label="item.name" :name="item.title" v-for="(item, index) in device_info.pic" :key="'pane'+index">
                  <div class="tabs_views" v-if="item.value.length>0">
                    <el-row :gutter="4">
                      <el-col
                        :span="8"
                        v-for="(item1, index1) in item.value"
                        :key="'col'+index1"
                      >
                        <div v-if="/^https?:\/\/(.+\/)+.+(\.(gif|png|jpg|jpeg|webp|svg|psd|bmp|tif))$/i.test(item1.value)" class="iframediv" style="height:200px;">
                          <el-image
                            style="width: 100%; height: 100%"
                            fit="cover"
                            :src="item1.value"
                            :z-index="9999"
                            :preview-src-list="srcList[item.title]"
                          ></el-image>
                          <span v-if="item1.key!==''" class="item_span_type">{{ item1.key }}</span>
                        </div>
                        <div v-else class="iframediv" style="height:100px;">
                          <iframe :src="item1.value" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
                          <span v-if="item1.key!==''" class="item_span_type">{{ item1.key }}</span>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <h3 v-else style=" 
                    display:flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    margin: auto;
                    margin-top: 30%;">暂无上传</h3>
                </el-tab-pane>
              </el-tabs>
              
            </div>
            
            <div class="tabs_views_right">
              <div v-for="(item, index) in device_info.font" :key="index">
                <div class="device_info_right">
                <h3 class="right_title_h3">{{item.title}}</h3>
              </div>
              <div style="width: 100%; margin: 0 auto">
                <el-row :gutter="24" style="margin: 0 auto;">
                  <el-col
                    :span="12"
                    v-for="(item1, index1) in item.value"
                    :key="index1"
                    style="padding: 5px;"
                  >
                    <span class="el_col_title"
                      ><span class="dian"></span>{{ item1.key + ":" }}</span
                    >
                    <span class="el_col_span"> {{ item1.value }}</span>
                  </el-col>
                </el-row>
              </div>
              </div>
          </div>
        </div>
        </el-tab-pane>
        <el-tab-pane label="配件信息" name="second">
          <el-table
            :data="accInfo_array.accheaderlist"
            border
            fit
            highlight-current-row
            style="width: 100%"
            :height="500"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <template v-for="(value, key) in accInfo_array.accheaderarr">
              <el-table-column
                :prop="key"
                :label="value"
                align="center"
                show-overflow-tooltip
              />
            </template>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="报警工单" name="third">
          <reporttablealarm
            :listLoading="listLoading"
            :tableColumns="tableColumnsalarm"
            :tableData="tableDataalarm"
            :sortChange="sortChange"
            :tableHeight="500"
          ></reporttablealarm>
        </el-tab-pane>
        <el-tab-pane label="报修工单" name="fourth">
          <reporttablerepair
            :listLoading="listLoading"
            :tableColumns="tableColumnsrepair"
            :tableData="tableDatarepair"
            :sortChange="sortChange"
            :tableHeight="500"
          ></reporttablerepair>
        </el-tab-pane>
        <el-tab-pane label="年检记录" name="inspection">
          <reporttableann
            :listLoading="listLoading"
            :tableColumns="tableColumnsann"
            :tableData="tableDataann"
            :sortChange="sortChange"
            :tableHeight="500"
          ></reporttableann>
        </el-tab-pane>
        <el-tab-pane label="离线记录" name="offlinerecord">
          <reporttableann
            :listLoading="listLoading"
            :tableColumns="tableDataoffline"
            :tableData="offlinerecord"
            :sortChange="sortChange"
            :tableHeight="500"
          ></reporttableann>
        </el-tab-pane>
        <el-tab-pane label="历史报警" name="historicalalarm">
            <el-table
            :data="historicalalarmdata"
            border
            fit
            highlight-current-row
            style="width: 100%"
            :height="500"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <template v-for="(value, key) in tableColumnhistoric">
              <el-table-column
                :prop="key"
                :label="value"
                align="center"
                show-overflow-tooltip
              />
            </template>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="周边场所" name="surrounding">
            <div class="surroun">
            <div class="map-serach">
            </div>
    
            <div class="surroun-left">
              <div class="amap_grope" ref="amapBox1">
              </div>
            </div>
            <div class="surroun-right">
              <div class="surroun-group" v-for="(item,index) in maplist" :key="index" @click="cardOnClick(item,index)">
                <el-card :class="item.select?'box-card-select':item.type==0?'box-card':'box-card-install'">
                    <div slot="header" class="clearfix">
                    <span style="font-weight:bold;font-size:18px;">{{ item.name }}</span>
                  </div>
                  <div class="text item">
                    {{ '地址：' + item.address }}
                  </div>
                  <div class="text item">
                    {{ '电话：' + item.tel }}
                  </div>
                  <div class="text item">
                    {{ item.distance==null?'距离：未知':'距离：' + item.distance + '米' }}
                  </div>
                </el-card>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="现场监控" name="video">
          <div class="tabs_views">
            <videoplay></videoplay>
          </div>
        </el-tab-pane>
        <el-tab-pane label="周边全景图" name="panorama">
          <!-- <div class="panorama-button">
            <el-button @click="uploadOnClick" type="primary">新增<i class="el-icon-upload el-icon--right"></i></el-button>
          </div> -->
          <div class="tabs_views">
                    <el-row :gutter="4">
                      <el-col
                        :span="24"
                        v-for="(item, index) in panorama"
                        :key="index"
                      >
                        <div style="position: relative; height: 200px">

                          <el-image
                            style="width: 100%; height: 100%"
                            fit="cover"
                            :src="require('../../../static/360-panorama/images/nx.png')"
                            @click="panoramaOnClick(item)"
                          ></el-image>
                          <span class="item_span_type" v-if="item.title!==''">{{ item.title }}</span>
                          <!-- <div class="item-panorama-updata"><el-button type="primary" icon="el-icon-edit" circle></el-button></div> -->

                        </div>

                      </el-col>
                    </el-row>

                  </div>
        </el-tab-pane>
      </el-tabs>
      <div class="el-form-list" v-if="innerVisible">
        <h2 class="el-form-infoedit">信息编辑</h2>

        <el-form ref="form" :model="form" label-width="70px">

        <el-form-item label="名称：">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="地址：">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="电话：">
          <el-input v-model="form.tel"></el-input>
        </el-form-item>
        <div class="submitt-button-grup">
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button @click="onColseSubmit">取消</el-button>
        </div>
      </el-form>
      </div>
      <div class="drawer-install-phone" v-if="drawer">
        <div class="drawer-install-close"><i class="el-icon-switch-button" style="font-size: 25px;color: aliceblue;" @click="onColseSubmit"></i></div>
        <div class="drawer-install-upload"><el-button @click="uploadOnClick" type="primary">保存<i class="el-icon-upload el-icon--right"></i></el-button></div>
        <div class="drawer-install-centent">
          <div class="drawer-item-up">
            <div v-if="imageUrlup" class="drawer-item-close"><el-button type="danger" icon="el-icon-delete" @click="onImageDeleteClick('up')" circle></el-button></div>
            <img v-if="imageUrlup" :src="imageUrlup" style="width: 100%;height: 100%">
            <label for="fileinp" v-else>
                <input type="button" id="btnup" value="点我上传"><span id="text">请上传正前方照片</span>
                <input type="file" id="fileinp" accept="image/jgp,image/png,image/jpeg" @change="uploadImgeOnClickup($event,'up')">
            </label>
          </div>
          <div class="drawer-item-dw">
            <div v-if="imageUrldw" class="drawer-item-close"><el-button type="danger" icon="el-icon-delete" @click="onImageDeleteClick('dw')" circle></el-button></div>
            <img v-if="imageUrldw" :src="imageUrldw" style="width: 100%;height: 100%">
            <label for="fileinp" v-else>
                <input type="button" id="btndw" value="点我上传"><span id="text">请上传身后方照片</span>
                <input type="file" id="fileinp" accept="image/jgp,image/png,image/jpeg" @change="uploadImgeOnClickdw($event,'dw')">
            </label>
          </div>
          <div class="drawer-item-fr">
            <div v-if="imageUrlfr" class="drawer-item-close"><el-button type="danger" icon="el-icon-delete" @click="onImageDeleteClick('fr')" circle></el-button></div>
            <img v-if="imageUrlfr" :src="imageUrlfr" style="width: 100%;height: 100%">
            <label for="fileinp" v-else>
                <input type="button" id="btnfr" value="点我上传"><span id="text">请上传头顶部照片</span>
                <input type="file" id="fileinp" accept="image/jgp,image/png,image/jpeg" @change="uploadImgeOnClickfr($event,'fr')">
            </label>
          </div>
          <div class="drawer-item-ou">
            <div v-if="imageUrlou" class="drawer-item-close"><el-button type="danger" icon="el-icon-delete" @click="onImageDeleteClick('ou')" circle></el-button></div>
            <img v-if="imageUrlou" :src="imageUrlou" style="width: 100%;height: 100%">
            <label for="fileinp" v-else>
                <input type="button" id="btnou" value="点我上传"><span id="text">请上传底部照片</span>
                <input type="file" id="fileinp" accept="image/jgp,image/png,image/jpeg" @change="uploadImgeOnClickou($event,'ou')">
            </label>
          </div>
          <div class="drawer-item-ri">
            <div v-if="imageUrlri" class="drawer-item-close"><el-button type="danger" icon="el-icon-delete" @click="onImageDeleteClick('ri')" circle></el-button></div>
            <img v-if="imageUrlri" :src="imageUrlri" style="width: 100%;height: 100%">
            <label for="fileinp" v-else>
                <input type="button" id="btnri" value="点我上传"><span id="text">请上传右侧方照片</span>
                <input type="file" id="fileinp" accept="image/jgp,image/png,image/jpeg" @change="uploadImgeOnClickri($event,'ri')">
            </label>
          </div>
          <div class="drawer-item-le">
            <div v-if="imageUrlle" class="drawer-item-close"><el-button type="danger" icon="el-icon-delete" @click="onImageDeleteClick('le')" circle></el-button></div>
            <img v-if="imageUrlle" :src="imageUrlle" style="width: 100%;height: 100%">
            <label for="fileinp" v-else>
                <input type="button" id="btnle" value="点我上传"><span id="text">请上传左侧方照片</span>
                <input type="file" id="fileinp" accept="image/jgp,image/png,image/jpeg" @change="uploadImgeOnClickle($event,'le')">
            </label>
          </div>
        </div>
      </div>
      <div class="drawer-install-phone" v-if="ispanorama">
        <div class="drawer-install-close"><i class="el-icon-switch-button" style="font-size: 25px;color: black;" @click="onColseSubmit"></i></div>
        <div class="drawer-install-iframe">
          <iframe
            :src="srcurl"
            class="panorama-iframe"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import reporttablealarm from '@/components/Table/template1.vue'
import reporttablerepair from '@/components/Table/template1.vue'
import reporttableann from '@/components/Table/template1.vue'
import videoplay from '@/components/video/CloudVideo.vue'
import dataUrl from "../../libs/js/interfaceAddress.js";

export default {
  components: {
    reporttablealarm,
    reporttablerepair,
    reporttableann,
    videoplay
  },
  props: {
    isdialogFormVisible: {
      type: Boolean,
      default: false
    },
    listLoading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    formdata: {
      type: Object
    },
    device_info: {
      type: Object
    },
    ishiddeCallBack: {
      type: Function
    }
  },
  data() {
    return {
    
      ispanorama: false,
      srcurl: '/static/360-panorama/index.html',
      screenHeight: document.documentElement.clientHeight, // 屏幕高度
      dialogFormVisible: false,
      innerVisible: false,
      drawer: false,
      tableheadarray: [],
      activeName: 'first',
      activeName1: 'device_picture',
      query: {
        page: '1',
        pageSize: 50,
        sort: '',
        search: {}
      },
      infoWindow:null,
      amap_map: null,
      selectmarkerCoor:null,
      levelBIcon: new AMap.Icon({
        size: new AMap.Size(20, 25), // 图标尺寸
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png', // Icon的图像
        imageSize: new AMap.Size(20, 25)
      }),
      levelCIcon: new AMap.Icon({
        size: new AMap.Size(25, 30), // 图标尺寸
        image: require('../../assets/images/alarm_redg.png'),
        imageSize: new AMap.Size(20, 25)
      }),
      markers: [],
      maplist: [],
      
      mapSearch:{
        radius:0,
        fields:''
      },
      center: null,
      accInfo_array: { accheaderarr: {}, accheaderlist: [] },
      tableDataalarm: [],
      tableDatarepair: [],
      tableColumnsann: [],
      tableColumnhistoric: [],
      historicalalarmdata: [],
      tableColumnsalarm: [
        {
          id: 73,
          parent_id: 0,
          route_name: 'alarm.list',
          field: 'time_begin',
          name: '报警时间',
          is_hide: '0',
          is_sort: '1',
          is_search: '1',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        },
        {
          id: 74,
          parent_id: 0,
          route_name: 'alarm.list',
          field: 'time_end',
          name: '结束时间',
          is_hide: '0',
          is_sort: '1',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        },
        {
          id: 75,
          parent_id: 0,
          route_name: 'alarm.list',
          field: 'time_clear',
          name: '清除时间',
          is_hide: '1',
          is_sort: '1',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        },
        {
          id: 76,
          parent_id: 0,
          route_name: 'alarm.list',
          field: 'alarm_type',
          name: '报警类型',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        },
        {
          id: 245,
          parent_id: 0,
          route_name: 'alarm.list',
          field: 'user_ops_id',
          name: '工程人员',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        },
        {
          id: 246,
          parent_id: 0,
          route_name: 'alarm.list',
          field: 'create_time',
          name: '派单时间\t',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        },
        {
          id: 247,
          parent_id: 0,
          route_name: 'alarm.list',
          field: 'receive_time',
          name: '接单时间',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        },
        {
          id: 248,
          parent_id: 0,
          route_name: 'alarm.list',
          field: 'report_time',
          name: '上报时间',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        },
        {
          id: 249,
          parent_id: 0,
          route_name: 'alarm.list',
          field: 'direction',
          name: '任务指示',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        }
      ],
      tableColumnsrepair: [
        {
          id: 230,
          parent_id: 0,
          route_name: 'repairComplete.list',
          field: 'type',
          name: '报修类型',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 20
        },
        {
          id: 241,
          parent_id: 0,
          route_name: 'repairComplete.list',
          field: 'repair_source',
          name: '报修来源',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 25
        },
        {
          id: 228,
          parent_id: 0,
          route_name: 'repairComplete.list',
          field: 'repair_user',
          name: '报修人',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 40
        },
        {
          id: 234,
          parent_id: 0,
          route_name: 'repairComplete.list',
          field: 'user_ops_id',
          name: '工程人员',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 45
        },
        {
          id: 229,
          parent_id: 0,
          route_name: 'repairComplete.list',
          field: 'time_start',
          name: '报修时间',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 50
        },
        {
          id: 235,
          parent_id: 0,
          route_name: 'repairComplete.list',
          field: 'create_time',
          name: '派单时间\t',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 55
        },
        {
          id: 238,
          parent_id: 0,
          route_name: 'repairComplete.list',
          field: 'direction',
          name: '任务指示',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 70
        },
        {
          id: 239,
          parent_id: 0,
          route_name: 'repairComplete.list',
          field: 'remark',
          name: '备注',
          is_hide: '1',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text',
          order: 600
        }
      ],
      offlinerecord: [],
      tableDataoffline: [
        {
          field: 'off_time',
          name: '离线时间',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text'

        },
        {
          field: 'on_time',
          name: '上线时间',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text'
        },
        {
          field: 'duration',
          name: '离线时长',
          is_hide: '0',
          is_sort: '0',
          is_search: '0',
          is_edit: '0',
          is_add: '0',
          is_required: '',
          form_type: 'text'
        }
      ],
      tableDataann: [],
      srcList: {},
      video_item_array: [],
      panorama: [
        {
          title: '751园区720全景图'
        }
      ]
    }
  },
  watch: {
    isdialogFormVisible: {
      handler: function(newVal) {
        this.dialogFormVisible = newVal
        if (newVal) {
          this.getData()
        }
      }
    }
  },
  computed: {},
  methods: {
    getData() {
      this.getuserlist()
    },
    requestdeviceMarkers() {
      var self = this
      this.$http.get(dataUrl.interfaceAddress.getDevMarkers, {
            params: { device_id:  this.formdata.deviceId }
        })
        .then(res => {
          if (res.data.code === 0) {
            this.mapSearch.radius = res.data.body.range
            this.mapSearch.searchtext = res.data.body.fields
            var circle = new AMap.Circle({
              center: this.center, //圆心
              radius: this.mapSearch.radius, //半径
              fillColor: '#1791fc',
              strokeColor: '#67C23A',
              fillOpacity: 0.3,
              zIndex: 50,
            })
            this.amap_map.add(circle);  
            this.peripherysearch(res.data.body)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    openInfo(item) {
        //构建信息窗体中显示的内容
        var info = [];
        info.push("<div class='input-card content-window-card'>");
        info.push("<div style=\"padding:7px 0px 0px 0px;\"><h3 style=\"padding:7px 0px 0px 0px;font-weight: bold;\">"+item.name+"</h3>");
        info.push("<p class='input-item'>电话 : "+item.tel+"  </p>");
        info.push("<p class='input-item'>地址 :"+item.address+"</p></div></div>");

        this.infoWindow = new AMap.InfoWindow({
          content: info.join(""),
          offset: new AMap.Pixel(0, -20)
        });
        this.infoWindow.open(this.amap_map, item.coord);
    },
    onColseSubmit() {
      this.innerVisible = false
      this.drawer = false
      this.ispanorama = false
    },
   
    panoramaOnClick() {
      this.ispanorama = true
    },
    uploadOnClick() {
      this.drawer = true
    },
    deleteOnClick(item, index) {
      console.log('数据删除操作')
      this.open(item, index)
    },
    editOnClick(item, index) {
      // this.form = item
      console.log('数据修改操作', this.form)
      this.innerVisible = true
    },
    cardOnClick(item, index) {
      this.selectmarkerCoor ? this.selectmarkerCoor.select = false : null
      item.select = !item.select
      item.select ? this.selectmarkerCoor = item : this.selectedMarker = null
      this.openInfo(item)
    },
    onSearchResult(events) {
      console.log('搜索返回数据', events)
      // console.log('搜索返回数据inedx', selectedTip)
    },
    // 获取表头数据
    getheaderlist(tablename, routeName) {
      var params = {
        routeName: routeName,
        updateTime: time
      }
      table_head_config(params).then((res) => {
        if (res.data.code !== 35) {
          if (tablename === 'alarmtask') {
            this.tableColumnsalarm = res.data.body.data
          } else if (tablename === 'repairtask') {
            this.tableColumnsrepair = res.data.body.data
          } else {
            this.tableColumnsann = res.data.body.data
          }
        }
      })
    },
    // 获取用户信息
    getuserlist() {
      this.srcList = {}
      this.device_info.pic.forEach((item, i) => {
        var arrs = []
        // 数组循环
        item.value.forEach((item1, i) => {
          // 数组循环
          arrs.push(item1.value)
        })
        this.srcList[item.title] = arrs
      })
    },
    handleClick(tab, event) {
      console.log('点击事件', tab.name)
      console.log('设备deviceID', this.formdata)
      this.query.search = { device_id: 'eq:' + this.formdata.deviceId }
      if (tab.name === 'second') {
          this.$http.get (dataUrl.interfaceAddress.getDevAccInfo, {params:{device_id: this.formdata.deviceId}}).then (res => {
            this.accInfo_array.accheaderarr = res.data.body.header
            this.accInfo_array.accheaderlist = res.data.body.list
          })
         .catch((err) => {
          this.accInfo_array.accheaderarr = {}
          this.accInfo_array.accheaderlist = []
         });
      } else if (tab.name === 'third') {
          this.$http.get(dataUrl.interfaceAddress.getDevAlarm,{params:this.query}).then (res => {
            this.tableDataalarm = res.data.body.data

          })
         .catch((err) => {
          this.tableDataalarm = []
         });
      } else if (tab.name === 'fourth') {
          this.$http.get(dataUrl.interfaceAddress.getDevRepairComplete,{params:this.query}).then (res => {
            this.tableDatarepair = res.data.body.data
          })
         .catch((err) => {
          this.tableDatarepair = []
         });
      } else if (tab.name === 'offlinerecord') {
          this.$http.get(dataUrl.interfaceAddress.getDevOfflineHistory,{params:{ device_id: this.formdata.deviceId }}).then (res => {
            this.offlinerecord = res.data.body
          })
         .catch((err) => {
          this.offlinerecord = []
         });

      } else if (tab.name === 'inspection') {
        this.getheaderlist('annualRecord', 'annualRecord.list')
        this.query.search = { device_id: 'eq:' + this.formdata.deviceId }
        this.$http.get(dataUrl.interfaceAddress.getDevAnnualRecord,{params:this.query}).then (res => {
          this.tableDataann = res.data.body.data
          })
         .catch((err) => {
          this.tableDataann = []
         });

      } else if (tab.name === 'historicalalarm') {
        this.$http.get(dataUrl.interfaceAddress.getDevalarmrecordOne,{ params:{device_id: this.formdata.deviceId }}).then (res => {
          this.tableColumnhistoric = res.data.body.header
          this.historicalalarmdata = res.data.body.data
        })
         .catch((err) => {
          this.tableColumnhistoric = []
            this.historicalalarmdata = []
         });
      } else if (tab.name === 'surrounding') {
        
        this.center = new AMap.LngLat(this.device_info.markerCoor.coord[0],this.device_info.markerCoor.coord[1])
        this.amap_map = new AMap.Map(this.$refs.amapBox1,{
          center: this.center, //设置地图初始化中心点位置
          zoom: 17,   //设置当前地图级别
          zooms:[3,24],
          resizeEnable: true
        });
        var marker = new AMap.Marker({
          position:this.center,
          icon: this.levelCIcon,
          anchor:'bottom-center',
          title: this.device_info.markerCoor.name,
          offset: new AMap.Pixel(0, 0)
        });    
        marker.setLabel({
          direction:'top',
          offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
          content: "<div class='info'>"+this.device_info.markerCoor.name+"</div>", //设置文本标注内容
        });
        // 将创建的点标记添加到已有的地图实例：
        this.amap_map.add(marker);
        this.requestdeviceMarkers()

      }
    },
    peripherysearch(body){
      var self = this
        AMap.plugin(["AMap.PlaceSearch"], function() {
            //构造地点查询类
            var placeSearch = new AMap.PlaceSearch({ 
                type: self.mapSearch.searchtext, // 兴趣点类别
                pageSize: 10, // 单页显示结果条数
                pageIndex: 1, // 页码
            });
            
            placeSearch.searchNearBy('', self.center, self.mapSearch.radius, function(status, result) {
              self.markers = []
              self.markers = result.poiList.pois
              self.maplist = []
              self.markers.forEach((e, i) => {
                if (!body.markerIds.includes(e.id)) {
                  // 数组循环
                  var item = {
                    name: e.name,
                    address: e.address,
                    tel: e.tel,
                    markerId: e.id,
                    select: false,
                    type: 0,
                    coord: [e.location.lng, e.location.lat],
                    distance: e.distance

                  }
                  self.maplist.push(item)
                  var marker = new AMap.Marker({
                    position:item.coord,
                    icon: self.levelBIcon,
                    anchor:'bottom-center',
                    title:e.name,
                    offset: new AMap.Pixel(0, 0)
                });
                marker.setMap(self.amap_map);
                }
              })
              body.list.forEach((e, i) => {
                // 数组循环
                var item = {
                  name: e.name,
                  address: e.address,
                  tel: e.tel,
                  markerId: e.markerId,
                  select: false,
                  type: 0,
                  coord: e.coord,
                  distance: e.distance
                }
                self.maplist.unshift(item)
                var marker = new AMap.Marker({
                    position:e.coord,
                    icon: self.levelBIcon,
                    anchor:'bottom-center',
                    title:e.name,
                    offset: new AMap.Pixel(0, 0)
                });
                marker.setMap(self.amap_map);
              })
              self.amap_map.setFitView()
         
            });
        });
    },
    sortChange(data) {},
    tableRowStyle({ row, rowIndex }) {
      return 'background-color:pink;font-size:12px;'
    },
    // 设置表头行的样式
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#409EFF;color:#fff;font-wight:500;font-size:14px;text-align:center'
    },
    hiddeBack() {
      this.config_close_init()
      this.listLoading = false
      this.ishiddeCallBack()
      console.log('页面消失了')
      this.markers = []
      this.maplist = []
      this.selectmarkerCoor = null
    },
    config_close_init() {
      this.activeName = 'first'
      this.activeName1 = 'device_picture'
      this.accInfo_array = { accheaderarr: {}, accheaderlist: [] }
      this.tableDatarepair = []
      this.tableColumnsann = []
      this.tableDataann = []
      this.srcList = {}
      this.tableColumnhistoric = []
      this.historicalalarmdata = []
      this.video_item_array = []
      this.device_info = {}
    },
    handleChange(value) {
      console.log(value)
    },
    handleDateClick(item) {
      console.log(JSON.stringify(item))
      this.formdata[item.field] = item.value
    }
  },
  created() {},
  mounted() {
    // setTimeout(() => {
    //   this.listLoading = false
    // }, 5000)
    this.formdata.deviceId = 69
  }
}
</script>
<style lang="less" scoped>

.el-form-list{
    position:absolute;
    z-index:999;
    top:0px;
    width: auto;
    height: auto;
    background-color:#E4E7ED;
    border-radius:5px;
    box-shadow:2px 2px 3px #aaaaaa;
    right:32%;
    top:28%;
    display:flex;
    flex-direction:column;
    align-items:center;
      .el-form-infoedit{
        text-align:center;
        align-items:center;
      }
    .submitt-button-grup{
       text-align:center;
       align-items:center;
       margin-bottom:10px;
    }
  }
.surroun{
    width: 100%;
    height: 500px;
    .map-serach{
      position: absolute;
      width: 67.5%;
      height: auto;
      z-index: 999;
      // background-color: rgba($color: #F2F6FC, $alpha: 0.8);
      box-shadow:2px 2px 3px #aaaaaa;

    }
    .map-serach-list::-webkit-scrollbar {
    display: none; /*隐藏滚动条*/
  }
    .handle-map {
      width: 43%;
      display: inline-block;
      padding: 5px;
    }
    .surroun-left{
      position: absolute;
      width: 67.5%;
      height: 100%;
      .amap_grope {
        position: absolute;
        top: 0%;
        width: 100%;
        height: 100%;
        .amap-demo {
          height: 100%;
        }
     }
    }
    .surroun-right{
      position: absolute;
      width: 30%;
      height: 97%;
      left: 69%;
      background-color: #EBEEF5;
      border-radius: 5px;
      overflow: auto;
      .surroun-group{

        background-color: #E4E7ED;

        width: 97%;
        height: auto;
        margin: 5px;
        border-radius: 5px;
        .box-card{
          background-color: #ffffff;

        }
        .box-card-install{
          background-color: #d3fce3;

        }
        .box-card-select{
          background-color: #eaedf3;

        }
      }
    }
  }
  .panorama-button{
    position:fixed;
    z-index: 999;
    right: 30px;
    top:20px
  }
.drawer-install-phone{
  position:fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  // background-color: rgba($color: #020202, $alpha: 0.9);
  // background-color: rgba($color: #DCDFE6, $alpha: 1);
  display:flex;
  justify-content: center;
  align-items:center;
  z-index: 9999;
    .drawer-install-close{
      position:absolute;
      z-index: 999;
      left: 30px;
      top:20px
    }
    .drawer-install-upload{
      position:absolute;
      z-index: 999;
      right: 30px;
      top:20px
    }
    .drawer-install-centent{
      position:absolute;
      width: 60%;
      height: 90%;
      margin-left: 10%;
      // background-color: #08d320;
      display:flex;
      justify-content: center;
      align-items: center;

      .drawer-item-up{
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        position:absolute;
        width: 30%;
        height: 30%;
        top: 0px;
        background-color: #EBEEF5;
      }
      .drawer-up-input{
          position:absolute;
          align-items: center;
          width: auto;
        }
        .drawer-item-close{
          position:absolute;
          right: 0px;
          top: 0px;
          margin:5px;

        }
        label{
            position: relative;
        }
        #fileinp{
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
        }
        #btn{
            margin-right: 5px;
        }
        #text{
            color: red;
        }
      .drawer-item-dw{
        display:flex;
        justify-content: center;
        align-items: center;
        position:absolute;
        width: 30%;
        height: 30%;
        bottom: 0px;
        background-color: #EBEEF5;
      }
      .drawer-item-fr{
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position:absolute;
        width: 30%;
        height: 30%;
        left: -35%;
        top: 35%;
        background-color: #EBEEF5;

      }
      .drawer-item-ou{

        display:flex;
        justify-content: center;
        align-items:center;
        position:absolute;
        width: 30%;
        height: 30%;
        background-color: #EBEEF5;
      }
      .drawer-item-le{
        display:flex;
        justify-content: center;
        align-items: center;
        position:absolute;
        width: 30%;
        height: 30%;
        left: 0px;
        background-color: #EBEEF5;
      }
      .drawer-item-ri{
        display:flex;
        justify-content: center;
        align-items: center;
        position:absolute;
        width: 30%;
        height: 30%;
        right: 0px;
        background-color: #EBEEF5;
      }
    }
    .panorama-iframe{
      height: 100%;
      width: 100%;
    }
    .drawer-install-iframe{
      position:absolute;
      width: 100%;
      height: 100%;
      // background-color: #08d320;
      display:flex;
      justify-content: center;
      align-items: center;
    }

}
  .surroun-right::-webkit-scrollbar {
    display: none; /*隐藏滚动条*/
  }
.tabs_views {
  width: 100%;
  height: 500px;
  .tabs_views_left {
    // margin-top: 0%;
    position: absolute;
    width: 48%;
    height: 100%;
    // margin-top: 1%;
    // background-color: #409EFF;
    // float: left;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: scroll;
    .iframediv {
      position: relative;
      overflow: hidden;
    }
    .iframediv iframe {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        transform-origin: top left;
        transform: scale(1)
    }

    // background-color: #4508d3;
  }

  .tabs_views_left::-webkit-scrollbar {
    display: none; /*隐藏滚动条*/
  }
  .right_title_h3 {
    position: relative;
    color: black;
    margin: 10px;
    font-weight: bold;
    // color:#409EFF;
    // background-color: #4508d3;
    // float: right;
  }
  .tabs_views_right {
    position: absolute;
    width: 49%;
    height: 96%;
    left: 50%;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: scroll;
    box-shadow:5px 5px 5px #aaaaaa;
    border-radius:5px;
    background-color: #EBEEF5;
    padding: 10px;

    .device_info_right{
      position: relative;
      // margin: auto;
      left: 0px;
      // padding: 5%;

    }
    .dian {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #08d320;
      margin-right: 10px;
    }
    .el_col_title {
      // font-weight: bold;
      font-size: 14px;
      color: black;
    }
    .el_col_span {
      position: absolute;
      font-size: 13px;
      color: rgb(31, 34, 34);
      // background-color: #08d320;
      height: auto;
      margin: auto;
      width: auto;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 2px;
    }
  }
  .tabs_views_right::-webkit-scrollbar {
    display: none; /*隐藏滚动条*/
  }
  .item-panorama-updata{
      position: absolute;
      right: 10px;
      top:10px;
    }
  .item_span_type {
    font-size: 12px;
    font-weight: 1000;
    color: #292626;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(220, 223, 230, 1);
    margin: 5px;
    padding: 5px;
  }
}
& /deep/ -webkit-scrollbar {
  display: none;
}
& /deep/ .el-col {
  padding-bottom: 10px;
}
& /deep/ .bg-purple-dark {
  background: #bf9f99;
}
& /deep/ .bg-purple {
  background: #d3dce6;
}
& /deep/ .bg-purple-light {
  background: #e5e9f2;
}
& /deep/ .grid-content {
  border-radius: 4px;
  min-height: 36px;
}
& /deep/ .row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
& /deep/ .el-dialog__header {
  background: url(../../../static/img/headbg.gif) no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
& /deep/ .el-dialog__title {
  color: rgb(149, 214, 245);
  font-size: 20px;
  font-weight: bold;
}
& /deep/ .el-dialog__body {
    padding: 10px 10px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
& /deep/ .el-icon-close:before {
  color: white;
}
& /deep/ .el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #dfe4ed;
  color: #3d3d3d;
  cursor: not-allowed;
}
& /deep/ .amap-page-container {
        height: 500px !important;
        position: relative;
        padding-top: 30px;
        margin: 0 auto;
    }
    & /deep/ .search-box-wrapper input{
   background: #F2F6FC;
}
& /deep/ .search-box {
        position: absolute;
        float: left;
        top: 3px;
        left: 3px;
        width: 55%;
    }
    & /deep/ .el-tag + .el-tag {
    margin-left: 10px;
  }
  & /deep/ .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  & /deep/ .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  //tag style
.text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 12px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  //搜索框style
& /deep/ .el-input--medium .el-input__inner {
    height: 36px;
    line-height: 36px;
    width: 300px;
    margin:7px;
}
& /deep/ .el-autocomplete-suggestion__wrap {
    max-height: 280px;
    padding: 10px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: grid;
}
& /deep/ .el-dialog__body {
    padding: 10px 10px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    background-color: whitesmoke;

}
& /deep/.custom-input-card{
            width: 18rem;
        }

        & /deep/.custom-input-card .btn:last-child{
            margin-left: 1rem;
        }

        & /deep/.content-window-card{
            position: relative;
            width: 23rem;
            padding: 0rem 0 0 0rem;
            box-shadow: none;
            bottom: 0;
            left: 0;
        }

        & /deep/.content-window-card p{
            height: 2rem;
        }
        & /deep/.amap-icon img {
            width: 25px;
            height: 34px;
        }
        & /deep/.input-item {
          padding-top: 5px;
          font-size: 14px;
        }
        
        & /deep/.amap-marker-label{
            border: 0;
            background-color: transparent;
        }

        & /deep/.info{
            position: relative;
            margin:0;
            top: 0;
            right: 0;
            min-width: 0;
        }
</style>



// WEBPACK FOOTER //
// src/components/infotabs/device_info_tabs.vue